import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ArrowLeft, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { deleteInterview } from "@/lib/deleteItem";
import { PageHeader } from "@/components/app/Common";
import { get } from "@/lib/api";
import { InterviewById } from "@/pages/candidates/interview/InterviewTab";

export default function InterviewDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const qc = useQueryClient();
  const { user } = useAuth();
  const staff = ["super_admin", "recruiter"].includes(user?.role);
  const { data } = useQuery({ queryKey: ["interview", id], queryFn: () => get(`/interviews/${id}`) });
  const iv = data?.interview;
  const snap = iv?.snapshot || {};
  const meta = [iv?.job_title, snap.practice_area, snap.pqe, snap.law_firm].filter(Boolean).join(" · ");
  return (
    <div className="space-y-6" data-testid="interview-detail-page">
      <Link to="/app/interviews" className="inline-flex items-center gap-1 text-sm text-ink-secondary hover:text-brand" data-testid="iv-detail-back"><ArrowLeft size={14} /> Interviews</Link>
      <PageHeader title={iv ? iv.candidate_name : "Interview"} subtitle={meta || undefined}>
        {snap.candidate_role && <p className="text-sm text-ink-muted" data-testid="iv-detail-role">{snap.candidate_role}</p>}
        {iv && !iv.parents_exist && <p className="text-xs text-ink-muted" data-testid="iv-detail-archived">Archived interview. The candidate and job records were cleared; the recording, transcript and scores are kept.</p>}
        {iv && staff && <Button variant="outline" size="sm" className="w-fit text-risk hover:text-risk" data-testid={`delete-interview-${iv.id}`}
          onClick={() => deleteInterview({ id: iv.id, name: iv.candidate_name, job_title: iv.job_title }, () => { qc.invalidateQueries({ queryKey: ["interviews"] }); nav("/app/interviews"); })}><Trash2 size={14} /> Delete interview</Button>}
      </PageHeader>
      <InterviewById id={id} />
    </div>
  );
}
